import { Chart as ChartJS, ArcElement, Tooltip, Legend, ChartOptions, ChartData } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import { useGetTheme } from '../../../modules/theme';
import { getColors, getLabels } from './doughnut-chart.function';

ChartJS.register(ArcElement, Tooltip, Legend);

interface DoughnutChartProps {
  labels: string[];
  values: number[];
}

export const DoughnutChart = ({ labels, values }: DoughnutChartProps) => {
  const theme = useGetTheme();
  const filteredData = values
    .map((value, index) => ({ value, label: labels[index] ?? '' }))
    .filter((entry) => entry.value > 0);

  const filteredLabels = filteredData.map((entry) => entry.label);
  const filteredValues = filteredData.map((entry) => entry.value);

  const data: ChartData<'doughnut'> = {
    labels: getLabels(filteredLabels, filteredValues),
    datasets: [
      {
        data: filteredValues,
        backgroundColor: getColors(theme)
      }
    ]
  };

  const options: ChartOptions<'doughnut'> = {
    responsive: true,
    aspectRatio: 2,
    plugins: {
      tooltip: {
        enabled: false
      },
      legend: {
        onClick: () => {
          return;
        },
        position: 'right',
        fullSize: true,
        labels: {
          font: {
            size: 14,
            family: 'Roboto'
          },
          usePointStyle: true,
          pointStyle: 'circle',
          boxWidth: 7,
          boxHeight: 7
        }
      }
    }
  };

  return <Doughnut data={data} options={options} />;
};
